import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { SendFcmNotificationPage } from './send-fcm-notification.page';
import {TranslateModule} from '@ngx-translate/core';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';

const routes: Routes = [
  {
    path: '',
    component: SendFcmNotificationPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    NgxDatatableModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule
  ],
  declarations: [SendFcmNotificationPage]
})
export class SendFcmNotificationPageModule {}
